window.dataLayer = window.dataLayer || [];

document.addEventListener('click', function(event) {
  const clickedLink = event.target.closest('a');
  const clickedElement = event.target.closest('a, button, input[type="submit"]');

  /**
   * select_item
   * Wird ausgelöst, wenn ein Nutzer auf ein Produkt aus einer Liste klickt.
   * Beispiel: Collection-Seite, Suchergebnisse, Produktempfehlungen.
   */
  if (clickedLink && clickedLink.href && clickedLink.href.includes('/products/')) {
    const productCard = clickedLink.closest('.card-wrapper, .product-card, .grid__item, li');
    const productTitleElement = productCard
      ? productCard.querySelector('.card__heading a, .full-unstyled-link, a[href*="/products/"]')
      : clickedLink;

    const productName = productTitleElement
      ? productTitleElement.textContent.trim()
      : clickedLink.textContent.trim();

    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        item_list_name: document.title,
        items: [{
          item_name: productName || null,
          item_url: clickedLink.href
        }]
      }
    });
  }

  /**
   * begin_checkout
   * Wird ausgelöst, wenn ein Nutzer auf "Zur Kasse" / Checkout klickt.
   */
  if (clickedElement) {
    const text = (clickedElement.textContent || clickedElement.value || '').trim().toLowerCase();
    const href = clickedElement.getAttribute('href') || '';
    const name = clickedElement.getAttribute('name') || '';

    const isCheckoutClick =
      href.includes('/checkout') ||
      name === 'checkout' ||
      text.includes('zur kasse') ||
      text.includes('checkout') ||
      text.includes('kasse');

    if (isCheckoutClick) {
      window.dataLayer.push({ ecommerce: null });

      window.dataLayer.push({
        event: 'begin_checkout'
      });
    }
  }
});

/**
   * add_to_cart
   */

(function () {
  window.dataLayer = window.dataLayer || [];

  const originalFetch = window.fetch;
  if (!originalFetch) return;

  function centsToDecimal(value) {
    return value ? value / 100 : 0;
  }

  function getAddedQuantity(body) {
    try {
      if (!body) return 1;

      if (body instanceof FormData) {
        return Number(body.get('quantity')) || 1;
      }

      if (body instanceof URLSearchParams) {
        return Number(body.get('quantity')) || 1;
      }

      if (typeof body === 'string') {
        const params = new URLSearchParams(body);
        return Number(params.get('quantity')) || 1;
      }

      if (typeof body === 'object') {
        if (body.quantity) return Number(body.quantity) || 1;
        if (body.items && Array.isArray(body.items) && body.items[0]?.quantity) {
          return Number(body.items[0].quantity) || 1;
        }
      }

      return 1;
    } catch (error) {
      return 1;
    }
  }

  function pushAddToCart(item, addedQuantity) {
    if (!item) return;

    const quantity = addedQuantity || 1;
    const price = centsToDecimal(item.final_price || item.price);

    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'EUR',
        value: Number((price * quantity).toFixed(2)),
        items: [{
          item_id: item.sku || String(item.variant_id || item.id),
          item_name: item.product_title || item.title || null,
          item_variant: item.variant_title || null,
          item_brand: item.vendor || null,
          item_category: item.product_type || null,
          price: price,
          quantity: quantity
        }]
      }
    });
  }

  window.fetch = async function () {
    const resource = arguments[0];
    const options = arguments[1] || {};
    const url = typeof resource === 'string' ? resource : resource && resource.url;

    const isAddToCart = url && url.includes('/cart/add');
    const addedQuantity = isAddToCart ? getAddedQuantity(options.body) : 1;

    const response = await originalFetch.apply(this, arguments);

    try {
      if (isAddToCart && response && response.ok) {
        const clonedResponse = response.clone();
        const data = await clonedResponse.json();

        if (data.items && Array.isArray(data.items)) {
          data.items.forEach(function (item) {
            pushAddToCart(item, item.quantity || addedQuantity);
          });
        } else {
          pushAddToCart(data, addedQuantity);
        }
      }
    } catch (error) {
      // Tracking darf den Shop niemals stören
    }

    return response;
  };
})();

/**
   * remove_from_cart
   */

(function () {
  window.dataLayer = window.dataLayer || [];

  if (window.__nadlerRemoveFromCartTrackingInstalled) return;
  window.__nadlerRemoveFromCartTrackingInstalled = true;

  const previousFetch = window.fetch;
  if (!previousFetch) return;

  function centsToDecimal(value) {
    return value ? value / 100 : 0;
  }

  function getItemKey(item) {
    return item.key || String(item.variant_id || item.id);
  }

  function mapCartItems(cart) {
    const map = {};

    if (!cart || !cart.items) return map;

    cart.items.forEach(function (item) {
      map[getItemKey(item)] = item;
    });

    return map;
  }

  function normalizeRemovedItem(item, removedQuantity) {
    const price = centsToDecimal(item.final_price || item.price);

    return {
      item_id: item.sku || String(item.variant_id || item.id),
      item_name: item.product_title || item.title || null,
      item_variant: item.variant_title || null,
      item_brand: item.vendor || null,
      item_category: item.product_type || null,
      price: price,
      quantity: removedQuantity
    };
  }

  function pushRemoveFromCart(currency, removedItems) {
    if (!removedItems || !removedItems.length) return;

    const value = removedItems.reduce(function (sum, item) {
      return sum + ((item.price || 0) * (item.quantity || 0));
    }, 0);

    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: {
        currency: currency || 'EUR',
        value: Number(value.toFixed(2)),
        items: removedItems
      }
    });
  }

  async function getCart() {
    const response = await previousFetch('/cart.js', {
      credentials: 'same-origin'
    });

    if (!response.ok) return null;

    return response.json();
  }

  function isCartRemoveOrUpdate(url) {
    if (!url) return false;

    try {
      const parsedUrl = new URL(url, window.location.origin);
      const path = parsedUrl.pathname;

      return (
        path.includes('/cart/change') ||
        path.includes('/cart/update')
      );
    } catch (error) {
      return false;
    }
  }

  function compareAndPushRemove(beforeCart, afterCart) {
    if (!beforeCart || !afterCart) return;

    const beforeItems = mapCartItems(beforeCart);
    const afterItems = mapCartItems(afterCart);
    const removedItems = [];

    Object.keys(beforeItems).forEach(function (key) {
      const beforeItem = beforeItems[key];
      const afterItem = afterItems[key];

      const beforeQuantity = beforeItem ? beforeItem.quantity : 0;
      const afterQuantity = afterItem ? afterItem.quantity : 0;

      if (beforeQuantity > afterQuantity) {
        removedItems.push(
          normalizeRemovedItem(beforeItem, beforeQuantity - afterQuantity)
        );
      }
    });

    pushRemoveFromCart(afterCart.currency || beforeCart.currency || 'EUR', removedItems);
  }

  window.fetch = async function () {
    const resource = arguments[0];
    const url = typeof resource === 'string' ? resource : resource && resource.url;

    const shouldTrackRemove = isCartRemoveOrUpdate(url);

    let beforeCart = null;

    if (shouldTrackRemove) {
      try {
        beforeCart = await getCart();
      } catch (error) {
        beforeCart = null;
      }
    }

    const response = await previousFetch.apply(this, arguments);

    if (shouldTrackRemove && response && response.ok) {
      try {
        const afterCart = await getCart();
        compareAndPushRemove(beforeCart, afterCart);
      } catch (error) {
        // Tracking darf den Shop niemals stören
      }
    }

    return response;
  };
})();

/**
   * newsletter_sign_up
   */

(function () {
  window.dataLayer = window.dataLayer || [];

  var newsletterSubmitPending = false;
  var newsletterEventSent = false;

  function isNewsletterButton(element) {
    if (!element) return false;

    var text = (element.textContent || '').trim().toLowerCase();
    var ariaLabel = (element.getAttribute('aria-label') || '').trim().toLowerCase();

    return (
      element.matches('button.submitButton[type="submit"]') &&
      (
        ariaLabel.includes('newsletter abonnieren') ||
        text.includes('newsletter abonnieren')
      )
    );
  }

  function hasNewsletterSuccessMessage() {
    var successMessage = document.querySelector('.onFormSubmittedFeedbackMessage');

    if (!successMessage) return false;

    var messageText = (successMessage.textContent || '').trim().toLowerCase();

    return messageText.includes('danke für deine anfrage');
  }

  function pushNewsletterSignUp() {
    if (newsletterEventSent) return;

    newsletterEventSent = true;

    window.dataLayer.push({
      event: 'newsletter_sign_up',
      form_type: 'newsletter_signup',
      page_path: window.location.pathname
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('button');

    if (!isNewsletterButton(button)) return;

    newsletterSubmitPending = true;

    setTimeout(function () {
      if (newsletterSubmitPending && hasNewsletterSuccessMessage()) {
        pushNewsletterSignUp();
      }
    }, 1500);
  });

  var observer = new MutationObserver(function () {
    if (!newsletterSubmitPending || newsletterEventSent) return;

    if (hasNewsletterSuccessMessage()) {
      pushNewsletterSignUp();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();

/**
   * generate_lead (contact_request)
   */

(function () {
  window.dataLayer = window.dataLayer || [];

  var contactRequestEventSent = false;
  var pendingKey = 'nadler_contact_request_pending';

  function isContactSubmitButton(element) {
    if (!element) return false;

    var text = (element.textContent || '').trim().toLowerCase();
    var className = element.className || '';

    return (
      element.matches('button[type="submit"]') &&
      className.includes('button--primary') &&
      text.includes('absenden')
    );
  }

  function hasContactSuccessMessage() {
    var successMessage = document.querySelector('.form__message.alert--success');

    if (!successMessage) return false;

    var successText = (successMessage.textContent || '').trim().toLowerCase();

    return successText.includes('danke, dass du uns kontaktiert hast');
  }

  function pushContactRequestLead() {
    if (contactRequestEventSent) return;

    contactRequestEventSent = true;
    sessionStorage.removeItem(pendingKey);

    window.dataLayer.push({
      event: 'generate_lead',
      lead_type: 'contact_request',
      lead_product_name: window.nadlerProductName || null
    });
  }

  function checkContactSuccess() {
    if (
      sessionStorage.getItem(pendingKey) === 'true' &&
      hasContactSuccessMessage()
    ) {
      pushContactRequestLead();
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('button');

    if (!isContactSubmitButton(button)) return;

    sessionStorage.setItem(pendingKey, 'true');

    setTimeout(function () {
      checkContactSuccess();
    }, 1500);
  });

  var observer = new MutationObserver(function () {
    checkContactSuccess();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  checkContactSuccess();
})();

/**
   * sign_up
   */

(function () {
  window.dataLayer = window.dataLayer || [];

  var signUpEventSent = false;
  var pendingKey = 'nadler_shop_registration_pending';

  function isRegistrationSubmitButton(element) {
    if (!element) return false;

    var text = (element.textContent || '').trim().toLowerCase();
    var className = element.className || '';

    return (
      element.matches('button[type="submit"]') &&
      className.includes('cf-submit-form') &&
      text.includes('registrierung einreichen')
    );
  }

  function hasRegistrationSuccessMessage() {
    var successHeading = document.querySelector('[data-cf-field-type="heading"] h1');

    if (!successHeading) return false;

    var successText = (successHeading.textContent || '').trim().toLowerCase();

    return successText.includes('vielen dank für deine registrierung');
  }

  function pushSignUpEvent() {
    if (signUpEventSent) return;

    signUpEventSent = true;
    sessionStorage.removeItem(pendingKey);

    window.dataLayer.push({
      event: 'sign_up'
    });
  }

  function checkRegistrationSuccess() {
    if (
      sessionStorage.getItem(pendingKey) === 'true' &&
      hasRegistrationSuccessMessage()
    ) {
      pushSignUpEvent();
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('button');

    if (!isRegistrationSubmitButton(button)) return;

    sessionStorage.setItem(pendingKey, 'true');

    setTimeout(function () {
      checkRegistrationSuccess();
    }, 1500);
  });

  var observer = new MutationObserver(function () {
    checkRegistrationSuccess();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  checkRegistrationSuccess();
})();

/**
   * Tracking-Status von Cookiebot an Shopify übergeben
   * für Checkout-Pixel notwendig
   */

(function () {
  var shopifyPrivacyApiLoaded = false;
  var syncInProgress = false;

  function loadShopifyPrivacyApi(callback) {
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function'
    ) {
      callback();
      return;
    }

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      setTimeout(function () {
        loadShopifyPrivacyApi(callback);
      }, 300);
      return;
    }

    if (shopifyPrivacyApiLoaded) {
      callback();
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1'
        }
      ],
      function (error) {
        if (error) {
          console.log('[Nadler Consent Bridge] Shopify Privacy API error:', error);
          return;
        }

        shopifyPrivacyApiLoaded = true;
        callback();
      }
    );
  }

  function getCookiebotConsent() {
    if (!window.Cookiebot || !window.Cookiebot.consent) {
      return null;
    }

    return {
      analytics: window.Cookiebot.consent.statistics === true,
      marketing: window.Cookiebot.consent.marketing === true,
      preferences: window.Cookiebot.consent.preferences === true
    };
  }

  function syncCookiebotConsentToShopify() {
    if (syncInProgress) return;

    var consent = getCookiebotConsent();

    if (!consent) return;

    syncInProgress = true;

    loadShopifyPrivacyApi(function () {
      if (
        !window.Shopify ||
        !window.Shopify.customerPrivacy ||
        typeof window.Shopify.customerPrivacy.setTrackingConsent !== 'function'
      ) {
        syncInProgress = false;
        return;
      }

      window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {
        console.log('[Nadler Consent Bridge] Cookiebot consent synced to Shopify:', consent);

        if (
          window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.currentVisitorConsent === 'function'
        ) {
          console.log(
            '[Nadler Consent Bridge] Shopify current visitor consent:',
            window.Shopify.customerPrivacy.currentVisitorConsent()
          );
        }

        syncInProgress = false;
      });
    });
  }

  window.addEventListener('CookiebotOnConsentReady', syncCookiebotConsentToShopify);
  window.addEventListener('CookiebotOnAccept', syncCookiebotConsentToShopify);
  window.addEventListener('CookiebotOnDecline', syncCookiebotConsentToShopify);

  var attempts = 0;

  var interval = setInterval(function () {
    attempts += 1;

    syncCookiebotConsentToShopify();

    if (window.Cookiebot && window.Cookiebot.consent) {
      clearInterval(interval);
    }

    if (attempts > 20) {
      clearInterval(interval);
    }
  }, 500);
})();

/**
   * quote_created und product_request
   * für App BSS B2B Quotes
   */

(function () {
  window.dataLayer = window.dataLayer || [];

  var pendingQuoteEvent = null;
  var pendingQuoteSetAt = 0;
  var lastQuoteSubmitAt = 0;

  function getClickedText(event) {
    var path = event.composedPath ? event.composedPath() : [];
    var texts = [];

    for (var i = 0; i < path.length; i++) {
      if (path[i] && path[i].textContent) {
        texts.push(path[i].textContent.trim().toLowerCase());
      }
    }

    return texts.join(' ');
  }

  function rememberQuoteType(event) {
    var clickText = getClickedText(event);

    if (clickText.includes('angebot per e-mail senden')) {
      pendingQuoteEvent = 'quote_created';
      pendingQuoteSetAt = Date.now();
    }

    if (clickText.includes('angebot anfragen')) {
      pendingQuoteEvent = 'product_request';
      pendingQuoteSetAt = Date.now();
    }
  }

  function pushQuoteEvent(eventName) {
    if (!eventName) return;

    window.dataLayer.push({
      event: eventName
    });

    pendingQuoteEvent = null;
    pendingQuoteSetAt = 0;
  }

  function isQuoteSubmitUrl(url) {
    return (
      url &&
      url.includes('/apps/customer-portal/api/r4q-quote/submit')
    );
  }

  function handlePerformanceEntry(entry) {
    if (!entry || !isQuoteSubmitUrl(entry.name)) return;

    var now = Date.now();

    // Deduplizierung, weil der Submit-Request mehrfach in Performance auftauchen kann
    if (now - lastQuoteSubmitAt < 3000) return;

    // Nur zählen, wenn vorher ein passender Angebots-Button geklickt wurde
    if (!pendingQuoteEvent) return;

    // Sicherheitsfenster: Event nur zählen, wenn der Klick nicht ewig zurückliegt
    if (now - pendingQuoteSetAt > 30 * 60 * 1000) {
      pendingQuoteEvent = null;
      pendingQuoteSetAt = 0;
      return;
    }

    lastQuoteSubmitAt = now;

    pushQuoteEvent(pendingQuoteEvent);
  }

  document.addEventListener('click', rememberQuoteType, true);

  if ('PerformanceObserver' in window) {
    var observer = new PerformanceObserver(function (list) {
      list.getEntries().forEach(handlePerformanceEntry);
    });

    observer.observe({
      entryTypes: ['resource']
    });
  }
})();